import {action} from "mobx";

import appStore from "./appStore";
import contractService from "../services/contractService";
import {courierContractService} from "services/courierContractService";

class contractStore {
    @action createAndShowContract = async params => {
        const resultOfRequest = await contractService.createAndShow(params);
        if (resultOfRequest.status !== 200 || resultOfRequest?.data?.success === false) {
            const error = resultOfRequest?.data?.error;
            const errorMessage = error?.message || "Sözleşme oluşturulamadı";
            if (error?.code === "CONTRACT_CREATION_ERROR") {
                //do nothing
            } else {
                appStore.openErrorModal({content: errorMessage});
            }

            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action uploadDocumentToTemplateContract = async params => {
        const resultOfRequest = await contractService.uploadDocumentToTemplateContract(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action getContractsBySubCompanyId = async params => {
        const resultOfRequest = await contractService.getContractsBySubCompanyId(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action changeApprovalStatus = async params => {
        const resultOfRequest = await contractService.changeApprovalStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
    };

    @action createContract = async params => {
        const resultOfRequest = await contractService.createContract(params);
        if (resultOfRequest.status !== 201) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest;
    };

    @action getContractTemplates = async () => {
        const resultOfRequest = await contractService.getContractTemplates();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data.result;
    };

    @action createTemplate = async params => {
        const resultOfRequest = await contractService.createTemplate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data.result;
    };

    @action changeContractTemplateActivation = async params => {
        const resultOfRequest = await contractService.changeContractTemplateActivation(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest;
    };

    @action getContractTypes = async () => {
        const resultOfRequest = await contractService.getContractTypes();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data.result;
    };

    @action generateContractPreview = async params => {
        const resultOfRequest = await contractService.generateContractPreview(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data.result;
    };

    @action getCourierContracts = async params => {
        try {
            const resultOfRequest = await courierContractService.getCourierContracts(
                params.courierId,
                params
            );
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data.result?.data?.contracts || [];
        } catch (error) {
            appStore.openErrorModal({content: error.message});
            return false;
        }
    };

    @action getCourierContractTemplates = async params => {
        try {
            const resultOfRequest = await courierContractService.getCourierContractTemplates(
                params.courierId
            );
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return resultOfRequest;
            }
            return resultOfRequest.data.result;
        } catch (error) {
            appStore.openErrorModal({content: error.message});
            return false;
        }
    };

    @action uploadCourierContract = async params => {
        try {
            const resultOfRequest = await courierContractService.uploadCourierContract(
                params.courierId,
                params.templateId,
                params.files
            );
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return resultOfRequest;
            }
            return resultOfRequest.data.result;
        } catch (error) {
            appStore.openErrorModal({content: error.message});
            return false;
        }
    };
}

export default new contractStore();
